import type { SVGProps } from 'react';
export const Reposition = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 3q.33 0 .54.27l1.36 1.8a.68.68 0 0 1-.55 1.1h-.67v2.02a.68.68 0 0 1-1.36 0V6.16h-.67a.68.68 0 0 1-.55-1.08l1.36-1.8A.7.7 0 0 1 10 3M5.79 8.04c.23.11.37.35.37.6v.68H8.2a.68.68 0 0 1 0 1.36H6.16v.67a.68.68 0 0 1-1.08.55l-1.8-1.36a.68.68 0 0 1 0-1.08l1.8-1.36c.2-.15.48-.18.7-.06m8.42 0c.23-.12.5-.1.71.06l1.8 1.36a.68.68 0 0 1 0 1.08l-1.8 1.36a.68.68 0 0 1-1.08-.55v-.67H11.8a.68.68 0 1 1 0-1.36h2.03v-.67c0-.26.14-.5.37-.61M10 11.13c.37 0 .68.3.68.68v2.03h.67a.68.68 0 0 1 .55 1.08l-1.36 1.8a.68.68 0 0 1-1.08 0l-1.36-1.8a.68.68 0 0 1 .55-1.08h.67V11.8c0-.38.3-.68.68-.68"
      clipRule="evenodd"
    />
  </svg>
);
